import React, {useState, ChangeEvent, useEffect} from 'react';
import ListView from "../components/List/ProgramList";
import {Link, useNavigate} from 'react-router-dom';
import { RootState } from '../store/store';
import {useDispatch, useSelector} from 'react-redux';
import {fetchPrograms} from "../store/ProgramSlice";
import debounce from 'lodash/debounce';

export default function Program() {
    const navigate = useNavigate();
    const [changeText, setChangeText] = useState(true);
   
    const dispatch = useDispatch<any>();
    const handleSearch = (query: string) => {
        dispatch(fetchPrograms({ search: query }));
    };
    const debouncedSearch = debounce(handleSearch, 300);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setChangeText(e.target.value === '');
        const query = e.target.value;
        debouncedSearch(query);
        // handleSearch(query); // Trigger search on every change
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setChangeText(e.target.value === '');
    };
    return (
        <>
            <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#263238]">Programs</h2>
            <div className="bg-white h-[calc(100vh-180px)] rounded-md overflow-y-auto">
                <div className="flex flex-col md:flex-row p-6 pb-4 ">
                    <form className="flex items-start w-80 md:w-1/2">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder=""
                                onChange={handleChange}
                                className="border rounded-md py-2 w-60 md:w-96 px-4 focus:outline-none placeholder-[#B0BEC5] bg-[#F5F7F8]"
                            />
                            {changeText && (
                                <div
                                    className="absolute inset-y-0 left-0 pt-1 pl-4 flex items-center pointer-events-none">
                                    <img src='./images/Vector.png' className="mx-auto mb-2 " width={18}
                                         alt="search"/> <span className='pl-1 leading-3   text-[#B0BEC5]'>Search</span>
                                </div>
                            )}
                        </div>
                    </form>
                <Link to="add" className="bg-[#B4804A] flex ml-0 md:ml-auto mt-4 md:mt-0 py-2 px-4 justify-center text-center items-center rounded-lg leading-8 font-gilroy font-bold  text-white w-60" ><img src='./images/plus.png' className="pr-2 object-contain	" alt="btn"/>Add New Programs</Link>
                </div>

                <ListView/>
            </div>
        </>
    )
}
    